import { useParams, Link, useLocation } from "react-router";
import { ArrowLongLeftIcon } from "@heroicons/react/24/outline";

import { Spinner } from "@/components/ui/spinner";

import { useClinician } from "../../api/get-clinicians";
import { ClinicianDetails } from "./clinician-details";
import { ServiceCard } from "./service-card";

export const ViewClinician = () => {
    // Get clinician
    const { id } = useParams();
    const { data: clinician = [], isLoading } = useClinician(id);

    const { state } = useLocation();
    const params = state?.params ?? "";

    if (isLoading || !clinician.userID) {
        return (
            <div className="relative col-span-full">
                <div className="absolute inset-0 z-10">
                    <div className="grid h-50 place-items-center py-10">
                        <Spinner size="lg" />
                    </div>
                </div>
            </div>
        );
    }

    return (
        <>
            <ClinicianDetails clinician={clinician} />
            <div className="relative flex h-full p-4 text-sm md:py-5">
                <div className="container mx-auto space-y-4">
                    <div>
                        <p className="text-xl font-medium">
                            Available Services
                        </p>
                    </div>
                    <div className="grid grid-cols-12 items-start gap-4">
                        {clinician.services?.map((service) => {
                            return (
                                <ServiceCard
                                    key={service.serviceGuid}
                                    clinician={clinician}
                                    service={service}
                                    params={params}
                                />
                            );
                        })}
                    </div>
                    <div className="mt-auto">
                        <Link
                            to={`/clinicians/find${params}`}
                            className="flex w-fit cursor-pointer items-center gap-2 p-2 text-base hover:text-darkgreen-400 hover:underline"
                        >
                            <ArrowLongLeftIcon className="size-4" />
                            Back to search
                        </Link>
                    </div>
                </div>
            </div>
        </>
    );
};
